import type { Cadence } from '../types.ts';

export const COMPOSITION_POLICY_VERSION = 'speech-bands-v2';
export const SPEECH_BANDS: Record<Cadence, [number, number]> = {
  opening: [.2, .3], occasional: [.35, .5], frequent: [.5, .7],
};
const SETTINGS = {
  opening: { preferred: .25, edge: .13, interval: 18, opening: .08, closing: .05, middle: .04, caps: [.1,.1,.075] },
  occasional: { preferred: .425, edge: .23, interval: 9, opening: .14, closing: .09, middle: .055, caps: [.18,.15,.12] },
  frequent: { preferred: .6, edge: .35, interval: 4.5, opening: .21, closing: .14, middle: .075, caps: [.26,.22,.18] },
};
export function compositionPolicy(cadence: Cadence, actualSec: number) {
  const s = SETTINGS[cadence];
  const middleCount = Math.round(actualSec / 60 * (1 - s.edge) / s.interval);
  return { ...s, band: SPEECH_BANDS[cadence], middleCount,
    middleRange: [Math.max(0, middleCount - 1), middleCount + 1] as [number,number] };
}
